export interface TaggingOptions {
  id?: string; // only for project or task id
  name?: string; // only for project or task name
  roles?: string[]; // list of roles
  callFrom?: string;
  agency?: string;
  client?: string;
  brand?: string;
}